import type { ViewsRestrictions } from '@/entities/session';
import { ViewAccessType, ViewType } from '@/entities/session';

export const getViewsRestrictionsCount = (
  viewsRestrictions: ViewsRestrictions,
) => {
  const availableViews = new Set(Object.values(ViewType));

  return Object.entries(viewsRestrictions).filter(
    ([view, access]) =>
      access === ViewAccessType.DENIED && availableViews.has(view as ViewType),
  ).length;
};
